/**
 * collapsible.js
 * Script to expand and collapse elements
 */

import { Collapsible as OrbitBase } from "../../original/js/components/collapsible";

export class Collapsible extends OrbitBase {
	// simulateClickOnScroll() {
	// 	// Fix. DONT REMOVE IT.
	// }

	collapseTrigger() {
		const siblings = this.element.parentElement.querySelectorAll(
			`[${this.attributes.ariaExpanded}]:not(.collapsible__trigger)`
		);

		this.element.classList.remove(this.classes.collapsibleTriggerExpanded);
		this.element.setAttribute(this.attributes.ariaExpanded, 'false');
		this.element.removeAttribute(this.attributes.expanded);

		// Handle collapse in siblings.
		if (siblings) {
			siblings.forEach(el => {
				el.setAttribute(this.attributes.ariaExpanded, 'false');
			});
		}
	}
	/**
	* Handles element on expand - add class and set aria expanded attribute
	*/
	expandTrigger() {
		const siblings = this.element.parentElement.querySelectorAll(
			`[${this.attributes.ariaExpanded}]:not(.collapsible__trigger)`
		);

		this.element.classList.add(this.classes.collapsibleTriggerExpanded);
		this.element.setAttribute(this.attributes.ariaExpanded, 'true');

		// Handle collapse in siblings.
		if (siblings) {
			siblings.forEach(el => {
				el.setAttribute(this.attributes.ariaExpanded, 'true');
			});
		}
	}

	collapseContent(initialHeight) {
    // Check if the content element is missing the data-rs-collapsible-content attribute - RXPIP-9772.
    if (!this.content.hasAttribute('data-rs-collapsible-content')) {
      console.error('Missing data-rs-collapsible-content attribute!');
    }
		// RBO-2104: IOS / android - 2nd level menu items cannot be closed
    this.content.style.maxHeight = '0px';
    this.content.setAttribute(this.attributes.content, '');
  }

}
